import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Box, Chip, TableCell, TableRow } from '@mui/material';
import { HTMLAttributes } from 'react';
import dayjs from 'dayjs';
import { DISPLAY_DATETIME_12H_FORMAT } from '@/utils/dateHelper';
import DehazeIcon from '@mui/icons-material/Dehaze';
import { useTranslation } from 'react-i18next';
import PublishedChip from '@/common/components/PublishedChip';
import { PUBLISHED_LISTB } from '@/common/constants/common';
import { showLabel } from '@/utils/helper';
import { QualityType } from '@/api/enum/common.enum';

type Props = {
	item: any;
} & HTMLAttributes<HTMLDivElement>;

const SortableArticlesItem = ({ item }: Props) => {
	const { t } = useTranslation();
	const {
		attributes,
		isDragging,
		listeners,
		setNodeRef,
		transform,
		transition,
	} = useSortable({
		id: item.id,
	});

	const qualityList = [
		{ id: QualityType.Normal, name: t('chartletList.normal') },
		{ id: QualityType.Rare, name: t('chartletList.rare') },
		{ id: QualityType.Precious, name: t('chartletList.precious') },
		{ id: QualityType.SuperPrecious, name: t('chartletList.superPrecious') },
	];

	const styles = {
		transform: CSS.Transform.toString(transform),
		transition: transition || undefined,
		opacity: isDragging ? '0.4' : '1',
		backgroundColor: isDragging ? '#F5F5F5' : '',
	};

	return (
		<>
			<TableRow ref={setNodeRef} style={styles}>
				<TableCell component='th' scope='row'>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
						<DehazeIcon cursor={'pointer'} {...listeners} {...attributes} />
						{`${item.titleZh || '-'}`}
					</Box>
				</TableCell>
				<TableCell component='th' scope='row'>
					{showLabel(item.quality, qualityList)}
				</TableCell>
				<TableCell component='th' scope='row'>
					{item.costPoints || '-'}
				</TableCell>

				<TableCell component='th' scope='row'>
					{`${
						!item.updatedAt
							? '-'
							: dayjs(item.updatedAt)
									.locale('en')
									.format(DISPLAY_DATETIME_12H_FORMAT)
					}`}
				</TableCell>
				<TableCell component='th' scope='row'>
					{`${
						!item.createdAt
							? '-'
							: dayjs(item.createdAt)
									.locale('en')
									.format(DISPLAY_DATETIME_12H_FORMAT)
					}`}
				</TableCell>
			</TableRow>
		</>
	);
};

export default SortableArticlesItem;
